import { mapGetters, mapActions, mapMutations } from "vuex";

import * as blogsStore from "@/store/Blogs";

export { blogsStore };

/**
 * Search store.
 *
 * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
 */
export const createBlogMixin = (without = []) => {
  const actions = !without.includes("actions")
    ? mapActions(blogsStore.moduleName, Object.keys(blogsStore.actionTypes))
    : {};
  const getters = !without.includes("getters")
    ? mapGetters(blogsStore.moduleName, Object.keys(blogsStore.getterTypes))
    : {};
  const mutations = !without.includes("mutations")
    ? mapMutations(blogsStore.moduleName, Object.keys(blogsStore.mutationTypes))
    : {};

  return {
    methods: {
      ...actions,
      ...mutations
    },
    computed: {
      ...getters
    }
  };
};
